export default {
  logout: {
    confirm: {
      title: 'Logout',
      message: 'Logout from your account?'
    },
    success: 'Logged out successfully',
    fail: 'An error occurred on logging out, try again'
  },
  pageNotFound: 'Page not found!',
  anErrorOccurred: 'An error occurred!',
  register: {
    terms: 'Accept terms and conditions and privacy',
    success: 'Registration done successfully'
  },
  passwordResetSuccessfully: 'Password reset successfully',
  profileInformationUpdatedSuccessfully:
    'Profile information updated successfully',
  legalInfoUpdatedSuccessfully: 'Legal information updated successfully',
  passwordChangedSuccessfully: 'Password changed successfully',
  passwordCreatedSuccessfully: 'Password created successfully',
  delete: {
    title: 'Delete {title}',
    message: 'Are you sure you want to delete this {title}?',
    success: '{title} deleted successfully'
  },
  create: '{title} created successfully',
  submit: '{title} submitted successfully',
  _edit: '{title} edited successfylly',
  registerOrder: {
    error: {
      gettingCompanyInfo:
        'There is a problem in receiving the information of the selected courier! Please try again'
    }
  },
  errorInSearchingAddress: 'Error in searching address!',
  map: {
    error: {
      extractAddress: 'Can not extract address! try again',
      locationPermissionDenied: 'Badpa is not allowed to access your location',
      extractLocation: 'Unable to get location'
    }
  },
  serverOffline: 'No connection to the server!',
  pleaseTryAgain: 'Please try again',
  thisPointCantBeSelected: "This point can't be selected",
  cancelTemporaryOrder: {
    title: 'Cancel order',
    message: 'Are you sure you want to cancel your order?',
    success: 'Order cancled successfully'
  },
  orderAutoCancel:
    'Unfortunately, no driver accepted your request! please re-order.',
  orderCanceledByDriver:
    'Your order canceled by driver! your order sent to other drivers.',
  orderCanceledByAdmin: 'Your order canceled by system admin! please re-order.',
  mobileConfirmedSuccessfully: 'Mobile confirmed successfully',
  emailConfirmedSuccessfully: 'Email confirmed successfully',
  loadDischargedSuccessfully: 'Load discharged successfully',
  originAndDestinationShouldDiffrent: 'Orogin and destination should diffrent'
}
